import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { concatPath } from '../../../../../helpers/path';
import { DevicesPath, ManagerPath, RootPath } from '../../../../../routes/manager/manager-enums';
import { useQrStore } from '../../../../../store/use-qr-store';
import { useLang } from '../../../../../hooks/use-lang';
import { validate } from '../../../../../helpers/validate';
import { validateLang } from '../../../../../helpers/lang';

export const useCreateDeviceQr = () => {
  const { postQr, isLoading, qr, handleResetQr, fetchQr, putQr } = useQrStore();
  const { t } = useLang();

  const [params] = useSearchParams();
  const id = params.get('id');

  useEffect(() => {
    if (id) fetchQr(id, 'AUTH_COMMON_DYNAMIC');

    return () => handleResetQr();
  }, [fetchQr, handleResetQr, id]);

  const navigate = useNavigate();

  const handleNext = async () => {
    const isValid = validate({
      name: { rule: () => validateLang(qr?.name) },
      branch: { rule: () => !!qr?.place_id },
    });
    if (!isValid) return;
    if (id) {
      await putQr('AUTH_COMMON_DYNAMIC');
      window.history.back();
    } else {
      await postQr('AUTH_COMMON_DYNAMIC');
      navigate(concatPath([RootPath.Manager, ManagerPath.Devices, DevicesPath.List]));
    }
  };

  return {
    handleNext,
    isLoading,
    id,
    t,
  };
};
